import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "ncore-ui-kit";

const stylesheet = StyleSheet.create({
    switchRow: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        width: "100%"
    },
    footerActionContainer: {
        justifyContent: "flex-end",
        flexDirection: "row",
        alignItems: "center",
        width: "100%"
    },
    notificationBadgeContainer: {
        justifyContent: "center",
        alignItems: "center"
    },
    logoUploadBox: {
        justifyContent: "center",
        borderStyle: "dashed",
        alignItems: "center",
        overflow: "hidden",
        height: 160,
        width: 160,
        ...webStyle({
            cursor: "pointer"
        })
    },
    coverUploadBox: {
        justifyContent: "center",
        borderStyle: "dashed",
        alignItems: "center",
        overflow: "hidden",
        aspectRatio: 4 / 5,
        height: 200,
        width: 160,
        ...webStyle({
            cursor: "pointer"
        })
    },
    uploadPlaceholder: {
        justifyContent: "center",
        alignItems: "center"
    },
    highlightedContainer: {
        flexDirection: "column",
        width: "100%"
    },
    typeButtonGroup: {
        alignSelf: "flex-start",
        flexDirection: "row",
        alignItems: "center"
    },
    qrCodeRow: {
        alignItems: "flex-end",
        flexDirection: "row",
        width: "100%"
    },
    uploadRow: {
        flexDirection: "row",
        width: "100%"
    },
    notificationContainer: {
        flexDirection: "row",
        alignItems: "center",
        width: "100%"
    },
    uploadDimensions: {
        textAlign: "center"
    },
    formCard: {
        overflow: "hidden",
        width: "100%"
    },
    switchTextContainer: {
        flex: 1
    },
    sectionTitle: {
        fontWeight: "700"
    },
    uploadLabel: {
        fontWeight: "600"
    },
    sectionContainer: {
        width: "100%"
    },
    uploadedImage: {
        height: "100%",
        width: "100%"
    },
    container: {
        width: "100%",
        flex: 1
    },
    headerContainer: {
        width: "100%"
    },
    sectionSubtitle: {
        width: "100%"
    },
    sectionHeader: {
        width: "100%"
    },
    formBody: {
        width: "100%"
    },
    typeButton: {
        minWidth: 120
    },
    qrCodeInput: {
        flex: 1
    },
    flex1: {
        flex: 1
    }
});

export default stylesheet;
